import type { GenericSize } from "../model/geom.js";
import type { PictureConfiguration } from "../model/picture.js";

function getPictureSourceImageBounds(
	canvasSourceImage: GenericSize<number>,
	{
		numberOfBasePlates,
		basePlateSize,
		imageZoom,
		imageZoomOffset,
	}: Pick<
		PictureConfiguration,
		"numberOfBasePlates" | "basePlateSize" | "imageZoom" | "imageZoomOffset"
	>,
) {
	const desiredAspectRatio =
		(numberOfBasePlates.width * basePlateSize) /
		(numberOfBasePlates.height * basePlateSize);
	const desiredAspectRatioWidth = canvasSourceImage.height * desiredAspectRatio;
	const desiredAspectRatioHeight = canvasSourceImage.width / desiredAspectRatio;
	const scaledWidth =
		Math.min(desiredAspectRatioWidth, canvasSourceImage.width) / imageZoom;
	const scaledHeight =
		Math.min(desiredAspectRatioHeight, canvasSourceImage.height) / imageZoom;
	const sourcePixelsPerBrick =
		scaledWidth / (numberOfBasePlates.width * basePlateSize);
	return {
		x:
			(canvasSourceImage.width - scaledWidth) / 2 -
			imageZoomOffset.x * sourcePixelsPerBrick,
		y:
			(canvasSourceImage.height - scaledHeight) / 2 -
			imageZoomOffset.y * sourcePixelsPerBrick,
		width: scaledWidth,
		height: scaledHeight,
	};
}

export default getPictureSourceImageBounds;
